// extracted by mini-css-extract-plugin
export default {"container":"menu_container__3s3xF"};